import type { ChatboButtontListItem } from "./types";
import { getProductSelectAction, getProductSelectTracking } from "./utils";

export const CHATBOT_STORE_IMAGES = `${
  process.env.NEXT_PUBLIC_BASE_URL_STORE || "https://store.snapptrip.com"
}/assets/chatbot`;

export const getChatbotStoreImageSrc = (imageName: string) =>
  `${CHATBOT_STORE_IMAGES}/${imageName}`;

export const CHATBOT_IMAGES = {
  chatBot: getChatbotStoreImageSrc("chat-bot.webp"),
  chatBotSecondary: getChatbotStoreImageSrc("chat-bot-secondary.svg"),
  rate1: getChatbotStoreImageSrc("rate-1.png"),
  rate2: getChatbotStoreImageSrc("rate-2.png"),
  rate3: getChatbotStoreImageSrc("rate-3.png"),
  rate4: getChatbotStoreImageSrc("rate-4.png"),
  rate5: getChatbotStoreImageSrc("rate-5.png")
} as const;

export const CHATBOT_ACTIONS_API = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/chatbot/v1/actions`;

export const CHATBOT_SEARCH_PARAMETER = "chatbot";

export const CHATBOT_TITLE = "پشتیبانی";

export const CHATBOT_GREETING_MESSAGE = `سلام \nمن دستیار پشتیبانی  اسنپ‌تریپ هستم 👋
لطفا سرویس مورد نظرتون رو انتخاب کنید تا بهتر راهنمایی‌تون کنم.`;

export const CHATBOT_ERROR_MESSAGE = "خطایی رخ داده است مجدد تلاش کنید";
export const CHATBOT_UNAUTHORIZED_ERROR_MESSAGE =
  "برای ادامه گفتگو، لطفاً وارد حساب کاربری خود شوید.";

export const CHATBOT_NEW_CONVERSATION_LABEL = "گفتگوی جدید";

export const FEEDBACK_MESSAGE = "ممنون از نظر شما 🙏";

export const MAX_TRACKING_CODE_SEARCH_QUERY_LENGTH = 14;

export const CHATBOT_PRODUCTS: Array<ChatboButtontListItem> = [
  {
    props: {
      title: "پرواز",
      icon: "flight",
      ...getProductSelectAction("start.flight-type-select"),
      ...getProductSelectTracking("flight")
    }
  },
  {
    props: {
      title: "اتوبوس",
      icon: "bus",
      ...getProductSelectAction("start.bus-type-select"),
      ...getProductSelectTracking("bus")
    }
  },
  {
    props: {
      title: "قطار",
      icon: "train",
      ...getProductSelectAction("start.train-type-select"),
      ...getProductSelectTracking("train")
    }
  },
  {
    props: {
      title: "هتل",
      icon: "hotel",
      ...getProductSelectAction("start.hotel-type-select"),
      ...getProductSelectTracking("hotel")
    }
  },
  {
    props: {
      title: "تور",
      icon: "tour",
      ...getProductSelectAction("start.tour-type-select"),
      ...getProductSelectTracking("tour")
    }
  },
  {
    props: {
      title: "ویلا",
      icon: "villa",
      ...getProductSelectAction("start.villa-type-select"),
      ...getProductSelectTracking("villa")
    }
  }
];

export const START_CHATBOT_ACTION = {
  id: "start.open",
  payload: {}
};

export const CHATBOT_PRODUCT_MENU_TITLE = "منوی اصلی";

export const CUSTOMER_FEEDBACK_OPTIONS = [
  {
    icon: CHATBOT_IMAGES.rate1,
    label: "خیلی بد",
    value: "1"
  },
  {
    icon: CHATBOT_IMAGES.rate2,
    label: "بد",
    value: "2"
  },
  {
    icon: CHATBOT_IMAGES.rate3,
    label: "معمولی",
    value: "3"
  },
  {
    icon: CHATBOT_IMAGES.rate4,
    label: "خوب",
    value: "4"
  },
  {
    icon: CHATBOT_IMAGES.rate5,
    label: "عالی",
    value: "5"
  }
];
